import React, {Component, Fragment} from "react";
import * as UserAPI from './../utils/api/userAPI'
import * as FeedAPI from './../utils/api/feedAPI'
import * as LoanAPI from './../utils/api/loanAPI'
import requesting from './../assets/images/icons/cash-payment.png'
import submit from './../assets/images/icons/share.png'
import {Navigate, NavLink, useNavigate} from "react-router-dom";
import {withAuth0} from "@auth0/auth0-react";
import {connect} from "react-redux";
import getNumberFromText from "../utils/helper/extractionNumber";
import  'react-activity-feed/dist/index.css'
import {Activity,ActivityFooter, CommentField, Title, LikeButton, CommentList, StatusUpdateForm, CommentItem} from 'react-activity-feed'
import Divider from "@mui/material/Divider";
import RecommendIcon from '@mui/icons-material/Recommend';
import IconButton from "@mui/material/IconButton";
import CommentIcon from '@mui/icons-material/Comment';
import PreviewIcon from '@mui/icons-material/Preview';
import AddCommentRoundedIcon from '@mui/icons-material/AddCommentRounded';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {getRequestCommentsAPI} from "./../utils/api/feedAPI";
import Box from "@mui/material/Box";


const withRouter = WrappedComponent => props => {
    const navigate = useNavigate();

    return (
        <WrappedComponent
            {...props}
            {...{ navigate, /* other hooks */ }}
        />
    );
};


class FeedRequestComponent extends Component{
    state ={
        profile:{},
        object:{},
        ticket:{},
        reaction: 0,
        comments:[]
    }
    componentDidMount() {
        this.retrieveToken()
            .then(token=> {
                UserAPI.getOtherUser(token,this.props.user)
                    .then((user) => {
                        this.setState({
                            profile: user.profile,
                        })
                    })
                FeedAPI.getRequestDetailAPI(token,(this.props.foreign_id))
                    .then((data) => {
                        this.setState({
                            object: data
                        })
                        LoanAPI.getTicketDetailAPI(token,(this.state.object.loanTicket))
                            .then((data) => {
                                this.setState({
                                    ticket: data
                                })
                            })
                    })
                FeedAPI.getRequestReactionAPI(token, this.props.foreign_id)
                    .then((data)=>{
                        this.setState({
                            reaction: data.reaction
                        })
                    })
                FeedAPI.getRequestCommentsAPI(token, this.props.foreign_id)
                    .then((data)=>{
                        this.setState({
                            comments: data
                        })
                    })
            })

    }
    handleReactToRequest = ()=>{
        this.retrieveToken()
            .then(token=> {
                FeedAPI.sendRequestReactionAPI(token, {}, this.props.foreign_id)
                    .then(r  =>{
                        this.setState({
                            reaction: r.reaction
                        })
                    })
            })
    }
    async retrieveToken(){
        const {getAccessTokenSilently} = this.props.auth0
        let accessToken;
        try{
            accessToken = await getAccessTokenSilently()
        }catch (e){
            console.error(e);
        }
        return accessToken;
    }
    handleRedirectProfilePage = (id)=>{
        const {navigate} = this.props
        navigate(`/users/${id}`)
    }
    handleRedirectMentionPage = (word)=>{
        const {navigate} = this.props
        navigate(`/mention/${word}`)
    }

    render() {
        return(
            <Fragment>
                <div className={"card"}>
                    <Activity
                        activity={{
                            actor:{
                                data:{
                                    name:this.state.profile.profile_name,
                                    profileImage:this.state.profile.avatar,
                                },
                            },
                            id: this.props.id,
                            verb:'request',
                            object:this.state.object.message,
                            image:this.state.object.image,
                            time:new Date(this.state.object.created_at).toJSON(),
                            reaction_counts:{
                                like:this.state.reaction,
                            },
                        }}
                        onClickHashtag={word => window.alert(`You clicked on ${word}`)}
                        onClickMention={word => this.handleRedirectMentionPage(word)}
                        onClickUser={data => this.handleRedirectProfilePage(this.state.profile.user)}
                        userId={this.state.profile.user}
                        Footer={({activity, userId})=>(
                            <div className={"card-footer"}>
                                <Title size={20}>
                                    {this.state.ticket.isClosed===true?
                                        <Typography variant="subtitle1" gutterBottom color={"#800020"}>Closed</Typography>:<></>
                                    }
                                    {this.state.object.title}
                                </Title>
                                <Divider/>
                                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                                    <Button onClick={this.handleReactToRequest} startIcon={<RecommendIcon/>}>
                                        {this.state.reaction}
                                    </Button>
                                    <Button startIcon={<CommentIcon/>}>
                                        {this.state.comments.length}
                                    </Button>
                                    {
                                        this.state.profile.user === this.props.authedUser.user?
                                            <Button startIcon={<PreviewIcon/>} component={NavLink} to={`/requests/${this.props.foreign_id}`}>
                                                View
                                            </Button>:
                                            <Button startIcon={<AddCommentRoundedIcon/>} component={NavLink} to={`/requests/${this.props.foreign_id}`}>
                                                Add
                                            </Button>
                                    }
                                </Stack>
                                {
                                    this.state.comments.slice(0,3).map(c=>(
                                        <CommentItem
                                            key={c.id}
                                            onClickHashtag={word => window.alert(`You clicked on ${word}`)}
                                            onClickMention={word => this.handleRedirectMentionPage(word)}
                                            onClickUser={data => this.handleRedirectProfilePage(c.user)}
                                            comment={{
                                                user: {
                                                    data: {
                                                        name: c.profile_name,
                                                        profileImage: c.profile_image,
                                                    },
                                                },
                                                created_at: new Date(c.created_at).toJSON(),
                                                data: {
                                                    text: c.message,
                                                },
                                            }}
                                        />
                                    ))
                                }
                                {this.state.comments.length > 3?
                                    <Box textAlign='center' m={1}>
                                        <Button variant={"outlined"} component={NavLink} to={`/requests/${this.props.foreign_id}`}>
                                            Load More
                                        </Button>
                                    </Box>
                                    :<></>
                                }
                            </div>
                        )}
                    />
                </div>
            </Fragment>

        )

    }
}

function mapStateToProps({authedUser}){
    return{
        authedUser
    }
}

const HOCUsersPage = withRouter(FeedRequestComponent)

export default connect(mapStateToProps)(withAuth0(HOCUsersPage))

/*
of $ {this.state.ticket.amount}
            <div className="card">
                <div className="feedBox">
                    <div className="feedBox-header">
                        <div className="feedBox-header-profile">
                            <img src={this.state.profile.avatar}/>
                            <p>
                                {this.state.profile.profile_name}
                            </p>
                        </div>
                    </div>
                    <div className="feedBox-body">
                        <h4><span>Loan Request of $ {this.state.ticket.amount}: </span>{this.state.object.title}</h4>
                        <p>{this.state.object.message}</p>
                        <img src={this.state.object.image}/>
                    </div>
                    <div className="feedBox-footer">
                        <div>
                            <NavLink to="#">
                                <img src={requesting} alt="requesting fund"/>
                                <span>
                                50
                            </span>
                            </NavLink>
                        </div>
                        <div>
                            <NavLink to="">
                                <img src={submit} alt="submit request"/>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
 */